import { Alert } from 'antd';

import './NoData.scss';

const NoData = ({
  description,
  type,
  message,
}: {
  description: string;
  type: 'info' | 'warning' | 'success' | 'error' | undefined;
  message: string;
}) => {
  return (
    <div className="nodata">
      <Alert message={message} description={description} type={type} showIcon />
    </div>
  );
};

export default NoData;
